import { render, staticRenderFns } from "./RoleLineMenu.vue?vue&type=template&id=2da09f97&scoped=true"
import script from "./RoleLineMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleLineMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RoleLineMenu.vue?vue&type=style&index=0&id=2da09f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da09f97",
  null
  
)

export default component.exports